import React from "react";
import moment from "moment";
import { RenderKilogramo } from "../../../../../../../../Utils/renderField/renderReadField";
import NullableValue from "../../../../../../../../Utils/renderField/nullableValue";
import { formatTitleConsumidorFinalEVS } from "../../../../../../helpers/formatValues";
import { ESTADOS_ORDEN_PRODUCCION } from "../../../../../../../../../../utility/constants";
import { TblActionsContent } from "./TblActionsContent";
const playIcon = require("assets/img/icons/play-icon.png");

export const OrdenesProdTable = ({
    ordenesProduccion,
    IniciarOrdenProduccion,
    CompletarOrdenProduccion,
    estado,
}) => {
    let table = null;

    const textoFecha = () => {
        if (estado === ESTADOS_ORDEN_PRODUCCION.PENDIENTE) {
            return "Fecha de creación";
        } else if (estado === ESTADOS_ORDEN_PRODUCCION.EN_PROCESO) {
            return "Fecha de inicio";
        } else if (estado === ESTADOS_ORDEN_PRODUCCION.COMPLETADO) {
            return "Fecha de finalización";
        }
    };

    if (estado === ESTADOS_ORDEN_PRODUCCION.PENDIENTE) {
        table = (
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Acciones</th>
                        <th>{textoFecha()}</th>
                        <th>EVS</th>
                        <th>Cliente</th>
                        <th>Producto a producir</th>
                        <th>Semana</th>
                        <th>Kg a producir</th>
                    </tr>
                </thead>
                <tbody>
                    {ordenesProduccion.length === 0 && (
                        <tr>
                            <td colSpan={7} className="text-center">
                                No hay órdenes de producción pendientes
                            </td>
                        </tr>
                    )}
                    {ordenesProduccion.map((item) => {
                        const fechaField = item["fecha_creacion"];

                        return (
                            <tr key={item.id}>
                                <td>
                                    <TblActionsContent
                                        item={item}
                                        IniciarOrdenProduccion={
                                            IniciarOrdenProduccion
                                        }
                                        CompletarOrdenProduccion={
                                            CompletarOrdenProduccion
                                        }
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={fechaField}>
                                        {moment(fechaField).format(
                                            "DD/MM/YYYY HH:mm",
                                        )}
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.evs.numero}
                                </td>
                                <td
                                    className="text-center text-nowrap"
                                    title={formatTitleConsumidorFinalEVS(
                                        item.evs,
                                    )}
                                >
                                    {item.evs.cliente.nombre}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.evs.producto_a_producir.nombre}
                                </td>
                                <td className="text-center text-nowrap">
                                    Semana {item.produccion.semana}
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={item.kg_a_producir}
                                        decimals={2}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    } else {
        table = (
            <table className="table-striped">
                <thead>
                    <tr>
                        <th>Acciones</th>
                        <th>{textoFecha()}</th>
                        <th>EVS</th>
                        <th>Cliente</th>
                        <th>Producto a producir</th>
                        <th>Kg a producir</th>
                        <th>Kg producidos</th>
                        <th>Kg pendientes</th>
                    </tr>
                </thead>
                <tbody>
                    {ordenesProduccion.length === 0 && (
                        <tr>
                            <td colSpan={8} className="text-center">
                                No hay órdenes de producción en proceso
                            </td>
                        </tr>
                    )}
                    {ordenesProduccion.map((item) => {
                        const fechaField =
                            estado === ESTADOS_ORDEN_PRODUCCION.COMPLETADO
                                ? item["fecha_final"]
                                : item["fecha_inicial"];

                        return (
                            <tr key={item.id}>
                                <td>
                                    <TblActionsContent
                                        item={item}
                                        IniciarOrdenProduccion={
                                            IniciarOrdenProduccion
                                        }
                                        CompletarOrdenProduccion={
                                            CompletarOrdenProduccion
                                        }
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <NullableValue value={fechaField}>
                                        {moment(fechaField).format(
                                            "DD/MM/YYYY HH:mm",
                                        )}
                                    </NullableValue>
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.evs.numero}
                                </td>
                                <td
                                    className="text-center text-nowrap"
                                    title={formatTitleConsumidorFinalEVS(
                                        item.evs,
                                    )}
                                >
                                    {item.evs.cliente.nombre}
                                </td>
                                <td className="text-center text-nowrap">
                                    {item.evs.producto_a_producir.nombre}
                                </td>

                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={item.kg_a_producir}
                                        decimals={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap ">
                                    <RenderKilogramo
                                        value={item.kg_paletizados}
                                        decimals={2}
                                    />
                                </td>
                                <td className="text-center text-nowrap">
                                    <RenderKilogramo
                                        value={item.kg_pendientes}
                                        decimals={2}
                                    />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }

    return (
        <div className="new-table-wrapper turnos-produccion__table-wrapper">
            {table}
        </div>
    );
};
